import { render, staticRenderFns } from "./Task_AbsentStudent.vue?vue&type=template&id=dd25dcb0&scoped=true&"
import script from "./Task_AbsentStudent.vue?vue&type=script&lang=js&"
export * from "./Task_AbsentStudent.vue?vue&type=script&lang=js&"
import style0 from "./Task_AbsentStudent.vue?vue&type=style&index=0&id=dd25dcb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd25dcb0",
  null
  
)

export default component.exports